var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-col',{attrs:{"cols":"12"}},[_c('p',{staticClass:"text1"},[_vm._v("Zorg je wel een beetje goed voor mij?")])]),_c('v-row',{staticClass:"avatar-box pa-4"},[_c('v-img',{attrs:{"src":_vm.item.avatar}})],1),_c('v-row')],1)}
var staticRenderFns = []

export { render, staticRenderFns }